export const geoApiOptions = {
	method: 'GET',
	headers: {
		'X-RapidAPI-Key': '6a74bf33aemsh342d035b125d83ep159da3jsnd6ae092fdee5',
		'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
	}
};


export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "073a0d9b0d3a3d2f1c50201dac894ec6";

/*   
   */

